import React, { useEffect, useMemo, useState } from 'react'
import { API, GOOGLE_MAP } from '../../../utils/Api';
import axios from 'axios';
import { Box, Button, FormControl, Grid, Hidden, InputAdornment, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import Images from '../../../utils/Images';
import { useNavigate } from 'react-router-dom';
import { AccessTime, ArrowDropDownOutlined, KeyboardArrowLeft, LocationOnOutlined, SearchOutlined } from '@mui/icons-material';
import toast from 'react-hot-toast';
import OutletSkeleton from '../../../components/SkeletonComponents/OutletSkeleton';

const DeliveryOutletScreen = () => {
    const navigate = useNavigate();
    const [allOutlets, setAllOutlets] = useState([]);
    const [selectedStore, setSelectedStore] = useState([]);
    const [fetchingOutlets, setFetchingOutlets] = useState(false);
    const [storeState, setStoreState] = useState("");
    const [query, setQuery] = useState('');
    const isMdUp = useMediaQuery(theme => theme.breakpoints.up('md'));
    const selectedDeliveryAddress = JSON.parse(localStorage.getItem("selectedAddress"));
    const latitude = localStorage.getItem("deliveryLatitude") || selectedDeliveryAddress?.coordinates?.latitude;
    const longitude = localStorage.getItem("deliveryLongitude") || selectedDeliveryAddress?.coordinates?.longitude;

    // console.log('selected address: ', selectedDeliveryAddress?.coordinates?.longitude);

    const [distance, setDistance] = useState(null);

    useEffect(() => {
        // Use dynamic origin if needed, or use the fixed origin from the URL
        // For example, using dynamic coordinates:
        const origin = `${latitude},${longitude}`;
        const destination = `15.5536192,73.8102094`;
        const apiKey = '8qkY7uxOWzHeRDGJk1OM0hTnrlkH7dDTxd4zBmiJ';

        // Construct the URL using encodeURIComponent to properly encode the coordinates
        const url = `https://api.olamaps.io/routing/v1/distanceMatrix?origins=${encodeURIComponent(origin)}&destinations=${encodeURIComponent(destination)}&mode=driving&api_key=${apiKey}`;

        // Alternatively, if you want to use the fixed origin from your provided URL, you can set:
        // const url = "https://api.olamaps.io/routing/v1/distanceMatrix?origins=15.487581838695137%2C%2073.8197504&destinations=15.5536192%2C%2073.8102094&mode=driving&api_key=8qkY7uxOWzHeRDGJk1OM0hTnrlkH7dDTxd4zBmiJ";

        fetch(url)
            .then(response => response.json())
            .then(data => {
                // Assuming the response structure is:
                // { results: { distances: [ [0, <distanceInMeters>] } } }
                console.log('data', data.rows[0].elements[0].distance);

                const distanceInMeters = data.rows[0].elements[0].distance;
                const distanceInKm = (distanceInMeters / 1000).toFixed(2);
                setDistance(distanceInKm);
            })
            .catch(error => {
                console.error('Error fetching distance:', error);
            });
    }, [latitude, longitude]);

    const stateOptions = useMemo(() => {
        const set = new Set((allOutlets || []).map(o => o?.state).filter(Boolean));
        return Array.from(set).sort((a, b) => a.localeCompare(b));
    }, [allOutlets]);

    const matchesQuery = (o, q) => {
        if (!q) return true;
        const hay = [
            o?.name,
            o?.city,
            o?.state,
            o?.address,
            String(o?.pincode || "")
        ].join(" ").toLowerCase();
        return hay.includes(q.toLowerCase());
    };

    const filteredOutlets = useMemo(() => {
        return (allOutlets || []).filter(o =>
            (storeState ? o?.state === storeState : true) && matchesQuery(o, query)
        );
    }, [allOutlets, storeState, query]);

    // const filteredUpcomingOutlets = useMemo(() => {
    //     return (upcomingOutlets || []).filter(o =>
    //         (storeState ? o?.state === storeState : true) && matchesQuery(o, query)
    //     );
    // }, [upcomingOutlets, storeState, query]);

    const getOutlets = async () => {
        setFetchingOutlets(true);
        try {
            const response = await axios.post(`${API.BASE_URL}outlet/getNearbyOutlets`, {
                "latitude": latitude,
                "longitude": longitude,
                // "minimumRadiusInKm":"5"
            }, {
                // headers: {
                //   Authorization: `Bearer ${usertoken}`,
                // },
            })
            console.log('All delivery outlets fetched', response?.data, "Latitude", latitude, "Longitude", longitude);
            setAllOutlets(response?.data?.data?.outlets);
            setFetchingOutlets(false);
        } catch (error) {
            console.log("Error fetching all the outlets", error);
        } finally {
            setFetchingOutlets(false);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getOutlets();
        if (selectedDeliveryAddress) {
        }
    }, []);

    const formatTo12Hour = (time) => {
        if (!time) return '';
        let [hour, minute] = time.split(':').map(Number);
        const ampm = hour >= 12 ? 'pm' : 'am';
        hour = hour % 12 || 12; // convert 0 → 12 and 13+ → 1-11
        return `${hour}:${minute.toString().padStart(2, '0')}${ampm}`;
    };

    const handleStoreClick = (outlet) => {
        localStorage.setItem('selectedStoreData', JSON.stringify(outlet));
        console.log('Selected store saved to local storage', outlet);
        toast.success("Outlet selected");
        if (isMdUp) {
            window.location.reload();
        } else {
            navigate('/productsListing');
        }
    };

    return (
        <Box sx={{ backgroundColor: '#09A5F7' }}>
            {allOutlets?.length < 0 ? (
                null
            ) : (
                <Box sx={{ position: 'relative', textAlign: 'center', padding: 1, paddingTop: 2, borderBottomRightRadius: '20px', borderBottomLeftRadius: '20px', backgroundColor: '#fff' }}>
                    <Typography className="title" sx={{ textAlign: 'center', color: '#0E4961', fontWeight: 'bold' }}>
                        <Hidden mdUp>
                            <KeyboardArrowLeft
                                onClick={() => navigate('/advertiseScreen')}
                                style={{ position: 'absolute', left: 15, top: '50%', paddingTop: 2, transform: 'translateY(-50%)', cursor: 'pointer' }}
                            />
                        </Hidden>
                        Choose the nearest store
                    </Typography>
                </Box>
            )}
            <Box className="pickupOutletScreen">
                {fetchingOutlets ? (
                    <>
                        <Box sx={{ margin: '8px 0 0 0' }}>
                            <OutletSkeleton />
                        </Box>
                    </>
                ) : (
                    <>
                        {allOutlets?.length === 0 ? (
                            <Typography className="title" onClick={() => navigate('/advertiseScreen')}><Hidden mdUp><KeyboardArrowLeft /></Hidden>No outlets found near your area.</Typography>
                        ) : (
                            <Grid container alignItems="center" sx={{ backgroundColor: '#fff', borderRadius: 2 }}>
                                <Grid item xs={5} md={6}>
                                    <FormControl fullWidth>
                                        <Select
                                            value={storeState}
                                            onChange={(e) => setStoreState(e.target.value)}
                                            displayEmpty
                                            IconComponent={ArrowDropDownOutlined}
                                            renderValue={(selected) => (selected ? selected : "All States")}
                                            sx={{
                                                borderRadius: 3,
                                                bgcolor: "#FFF",
                                                "& .MuiSelect-select": {
                                                    py: 1.25,
                                                    fontWeight: 600,
                                                    fontSize: "1.1rem",
                                                },
                                                "& fieldset": { borderColor: "#fff" },
                                                "&:hover fieldset": { border: 'none' },
                                                "&.Mui-focused fieldset": { border: "none" },
                                            }}
                                        >
                                            <MenuItem value="">All States</MenuItem>
                                            {stateOptions.map(s => (
                                                <MenuItem value={s}>{s}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={7} md={6} paddingRight={1}>
                                    <TextField
                                        fullWidth
                                        placeholder="Type your location"
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchOutlined />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                height: 32,
                                                borderRadius: 1,
                                                bgcolor: "#F0F7FF",
                                                "& fieldset": { border: 'none' },
                                                "&:hover fieldset": { borderColor: "#7CC4FF" },
                                                "&.Mui-focused fieldset": { borderColor: "#3EA0FF" },
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                        {filteredOutlets?.filter(outlet => outlet.status === "ACTIVE").map(outlet => (
                            <Grid className="pickupOutlet" key={outlet?._id} container
                                sx={{ cursor: !outlet?.isOutletClosed ? 'pointer' : 'not-allowed' }}
                                onClick={() => {
                                    if (!outlet?.unavailabilityMessage) {
                                        handleStoreClick(outlet)
                                    }
                                }}>
                                <Grid item xs={4}>
                                    <Box sx={{ position: 'relative', width: '100%', height: '80%', justifyContent: 'center' }}>
                                        <img className='outletImage' src={outlet?.outletImage} alt={outlet?.name} />
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Box
                                                className="openMapButton"
                                                onClick={() => {
                                                    const googleMapsUrl = `https://www.google.com/maps/place/${outlet?.coordinates?.latitude},${outlet?.coordinates?.longitude}`;
                                                    window.open(googleMapsUrl, '_blank');
                                                }}
                                            >
                                                View Maps
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={8} sx={{ paddingLeft: '6px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <Typography className="outletName">{outlet?.name}<span className="outletCity">, {outlet?.city}, {outlet?.state}.</span></Typography>
                                    <Box>
                                        <Box sx={{ display: 'flex' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <AccessTime fontSize='12' sx={{ color: '#09A5F7' }} />
                                                <Typography className="outletTiming">{formatTo12Hour(outlet?.openingTime)} - {formatTo12Hour(outlet?.closingTime)}</Typography>
                                            </Box>
                                            <Box>
                                                {outlet?.unavailabilityMessage ? (
                                                    <>
                                                        {outlet?.unavailabilityMessage === "The outlet has been closed temporarily" ? (
                                                            <Typography className='outletTemporarily'>Temporarily Closed</Typography>
                                                        ) : (
                                                            <Typography className='outletClosed'>Closed</Typography>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Typography className='outletOpen'>Open</Typography>
                                                )}
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', paddingTop: '4px' }}>
                                            <LocationOnOutlined fontSize='12' sx={{ color: '#09A5F7' }} />
                                            <Typography className="outletAddress">{outlet?.address}, {outlet?.pincode}.</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        ))}
                    </>
                )
                }
            </Box >
        </Box >
    )
}

export default DeliveryOutletScreen;

// <Grid className="pickupOutlet" key={outlet?._id} container>
//                             <Grid item xs={5}>
//                                 <img style={{ borderRadius: '12px', width: '100%', height: '90%', objectFit: 'cover', filter: outlet?.unavailabilityMessage ? 'grayscale(100%)' : 'none' }} src={outlet?.outletImage} alt={outlet?.name} />
//                             </Grid>
//                             <Grid item xs={7} sx={{ paddingLeft: '6px' }}>
//                                 <Typography className="outletName">{outlet?.name}</Typography>
//                                 <Typography className="outletCity">{outlet?.city}, {outlet?.state}, {outlet?.country}</Typography>
//                                 <Typography className="outletAddress">{outlet?.address}</Typography>
//                                 <Typography className="outletAddress">{outlet?.pincode}</Typography>
//                                 {/* <Box className="openMapButton">Open Maps</Box> */}
//                                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                                     <Box className="openMapButton" sx={{ marginLeft: 'auto', cursor: 'pointer' }} onClick={() => {
//                                         const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${outlet?.coordinates?.latitude},${outlet?.coordinates?.longitude}`;
//                                         window.open(googleMapsUrl, '_blank');
//                                     }}>
//                                         Open Maps
//                                     </Box>
//                                 </Box>
//                             </Grid>
//                             <Grid item xs={12}>
//                                 {outlet?.orderAcceptType === 'PICKUP' ? (
//                                     <Typography className='outletDeliveryUnavailable'>Delivery Unavailable</Typography>
//                                 ) : (
//                                     outlet?.unavailabilityMessage ? (
//                                         <Typography className='outletClosed'>Closed</Typography>
//                                     ) : (
//                                         <Typography className='outletOpen'>Open</Typography>
//                                     )
//                                 )}
//                             </Grid>
//                         </Grid>